import { ApiEndpoints } from "../../helper/ApiEndpoints";
import Contact from "./Contact";

const tableHeader = ["Date", "Form Type", "Company Name", "Contact Name", "Work Email", "Contact Number", "Role / Title", "Number of Pax", "Package", "Start Date", "Wellness Goal", "Message", "IP Address", "Source Url", "Current Url"];
const tbody = ["createdAt", "form_type", "company_name", "name", "email", "phoneNumber", "role_title", "number_of_pax", "package", "check_in", "wellness_goal", "message", "ip_address", "source_url", "current_url"];

export default function CorporateQuery() {
  return (
    <Contact
      endpoint={ApiEndpoints.contact.corporateQueryList}
      title="Corporate Query"
      tableHeader={tableHeader}
      tbody={tbody}
    />
  );
}
